





















import {Component, Mixins, Prop, Vue, Watch} from 'vue-property-decorator';
import {nil} from '@/common';
import LocationMixin from '@/mixins/LocationMixin.vue';
import GenericDialog from "@/components/Views/UI/GenericDialog.vue";

@Component({
    components: {
        GenericDialog
    },
})
export default class WhiteListedLocationsDialog extends Mixins(LocationMixin) {
    public open(){
        this.dialogOpen = true;
    }

    public dialogOpen: boolean = false;
    @Watch('formattedAddress')

            get countiesHalf(){
        return Math.ceil(this.whiteListedCounties.length / 2);
    }

    get countiesLeft(){
        return this.whiteListedCounties.slice(0,this.countiesHalf);
    }
    get countiesRight(){
        return this.whiteListedCounties.slice(this.countiesHalf, this.whiteListedCounties.length);
    }
    get citiesHalf(){
        return Math.ceil(this.whiteListedCities.length / 2);
    }

    get citiesLeft(){
        return this.whiteListedCities.slice(0,this.citiesHalf);
    }
    get citiesRight(){
        return this.whiteListedCities.slice(this.citiesHalf, this.whiteListedCities.length);
    }
}
